// Détecter si l'appareil est tactile
export const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

export const chooseRandomName = (names) => {
    // Calcul de la somme totale des poids
    const poidsTotal = names.reduce((acc, { poids }) => acc + poids, 0);

    // Tirage aléatoire pondéré
    let tirage = Math.random() * poidsTotal;
    
    // Sélection du nom basé sur le tirage
    for (const { name, poids } of names) {
        if (tirage < poids) {
            return name;
        }

        tirage -= poids;
    }
}

export const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback.apply(null, args);
        }, wait);
    };
}

/** Fonctions pour générer un nombre aléatoire  */
export const getRandomNumber = (min, max, rounded) => {
    const rand = Math.random() * (max - min) + min
    return typeof rounded === "undefined" ? rand : Math.ceil(rand);
}

export const generatePhoneNumber = () => {
    // Génère un nombre aléatoire entre 0 et 9
    // Mais ajuste la probabilité pour favoriser le '6' sur le '7'
    let prefixe = Math.random() < 0.7 ? '06' : '07';

    // Génère les 8 chiffres restants du numéro de téléphone de manière aléatoire
    let suffixe = '';
    for (let i = 0; i < 8; i++) {
        suffixe += Math.floor(Math.random() * 10); // Génère un chiffre aléatoire entre 0 et 9
    }

    // Concatène le préfixe et le suffixe pour former le numéro de téléphone
    return prefixe + suffixe;
}

export const genererCalcul = () => {
    const operandes = [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10)];
    const operateurs = ['+', '-', '*'];
    const operateur = operateurs[Math.floor(Math.random() * operateurs.length)];
    let question, reponse;

    switch (operateur) {
        case '+':
            question = `${operandes[0]} + ${operandes[1]}`;
            reponse = operandes[0] + operandes[1];
            break;
        case '-':
            question = `${operandes[0]} - ${operandes[1]}`;
            reponse = operandes[0] - operandes[1];
            break;
        case '*':
            question = `${operandes[0]} * ${operandes[1]}`;
            reponse = operandes[0] * operandes[1];
            break;
    }

    return { question, reponse };
}

export const verifierReponse = () => {
    const calcul = genererCalcul();
    const userReponse = prompt(`Résolvez ceci pour prouver que vous êtes humain : ${calcul.question}`);
    if (parseInt(userReponse) === calcul.reponse) {
        alert("Bonne réponse ! Vous pouvez envoyer le formulaire.");
        return true;
    } else {
        alert("Mauvaise réponse. Essayez encore.");
        return false;
    }
}